import { render, staticRenderFns } from "./BreadcrumbComponent.vue?vue&type=template&id=0817f69e&scoped=true&"
import script from "./BreadcrumbComponent.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbComponent.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbComponent.vue?vue&type=style&index=0&id=0817f69e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0817f69e",
  null
  
)

export default component.exports